<template>
  <v-container fluid>
    <h2 class="mb-4 blue--text">
      {{ $attrs.selectedClassGroup.STUDENT_GROUP_NAME }},
      {{ $attrs.selectedClassGroup.STUDENT_GROUP_ID }}
    </h2>
    <p class="my-0 py-0" v-if="$attrs.classStudents">
      Сурагчийн тоо: {{ $attrs.classStudents.length }},
      <span v-if="$attrs.finalExamsCalendars">{{
        $attrs.finalExamsCalendars.length
      }}</span>
    </p>
    <v-row class="mb-4" v-if="sortedItems && sortedItems.length > 0">
      <v-col class="text-end">
        <v-btn class="bg-gradient-danger" dark @click="_retriveExams"
          >Шалгалтын xуваарь даxин татаx</v-btn
        >
      </v-col>
    </v-row>
    <v-row justify="center" class="my-10 py-10" v-else-if="!loading">
      <v-btn
        class="bg-gradient-danger text-h3"
        height="100"
        dark
        @click="_retriveExams"
        >Энд дарж шалгалтын xуваариа татна уу!!!!</v-btn
      >
    </v-row>
    <v-progress-linear
      v-if="loading"
      color="red"
      height="6"
      indeterminate
    ></v-progress-linear>
    <v-data-table
      v-if="sortedItems && sortedItems.length > 0"
      :headers="headers"
      :items="sortedItems"
      item-value="EXAM_TYPE"
      group-by="categoryID"
      class="elevation-1 fixed-table"
      hide-default-footer
      :items-per-page="-1"
    >
      <template v-slot:group.header="{ items }">
        <td
          :colspan="headers.length"
          class="group-header"
          style="background: #f8f8f8 !important"
        >
          <strong>{{ items[0].EXAM_TYPE }}</strong>
        </td>
      </template>

      <template v-slot:item.EXAM_NAME="{ item }">
        <span @click="_print(item)"> {{ item.EXAM_NAME }}</span>
        <p class="blue--text">{{ item.TEST_COMPONENT_SESSION_ID }}</p>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn class="bg-gradient-danger" dark small @click="_doUnelgee(item)"
          >Үнэлгээ+</v-btn
        >
      </template>

      <template v-slot:item.icons="{ item }">
        <v-progress-linear
          v-if="loadingStudents"
          color="red"
          height="6"
          indeterminate
        ></v-progress-linear>
        <template v-else>
          <v-icon
            small
            class="mr-6"
            @click="_openAddStudentDialogToLesson(item)"
            >mdi-account-plus</v-icon
          >

          <v-icon small @click="_removeStudentToLesson(item)"
            >mdi-account-minus</v-icon
          >
        </template>
      </template>

      <template v-slot:item.number_Students="{ item }">
        <v-chip color="#fde388" v-if="item.number_Students > 0">
          {{ item.number_Students }}
        </v-chip>
        <v-chip v-else color="#F8F9FA"> 0 </v-chip>
      </template>

      <template v-slot:item.number_ScoreApproved="{ item }">
        <v-chip
          color="#82d616"
          v-if="item.number_ScoreApproved > 0 && item.number_Students"
        >
          {{ item.number_ScoreApproved }}
        </v-chip>
        <v-chip v-else-if="item.number_Students" color="#F8F9FA"> 0 </v-chip>
      </template>

      <template v-slot:item.BEGIN_DATE_TIME="{ item }">
        {{ _getDatee(item.BEGIN_DATE_TIME) }}
      </template>
      <template v-slot:item.END_DATE_TIME="{ item }">
        {{ _getDatee(item.END_DATE_TIME) }}
      </template>

      <template v-slot:item.actions2="{ item }">
        <v-btn
          class="bg-gradient-info"
          dark
          small
          @click="_callEsisSavedInfo(item)"
          >Төлөв шалгаx</v-btn
        >
      </template>
    </v-data-table>

    <v-dialog
      v-model="addStudentToLessonDialog"
      max-width="1000px"
      v-if="$attrs.selectedClassGroup"
    >
      <v-card class="card-shadow border-radius-xl">
        <div class="card-header-padding card-border-bottom">
          <span class="font-weight-bold text-h5 text-typo mb-0">
            Шалгуулагч бүртгэх
            <!-- <span
              class="blue--text"
              v-if="selectedLesson && selectedLesson.classGroups"
              >{{
                selectedLesson.classGroups
                  .map((a) => a.classGroupFullName)
                  .join(", ")
              }}</span
            > -->
          </span>
        </div>
        <v-card-text class="card-padding">
          <p
            class="text-end"
            v-if="selectedAddStudents && selectedExamStudents"
          >
            <span class="green--text"
              >Сонгогдсон: {{ selectedAddStudents.length }}</span
            >
            |
            <span class="red--text">
              Сонгогдоогүй:
              {{
                selectedExamStudents.length - selectedAddStudents.length
              }}</span
            >
          </p>
          <v-data-table
            v-if="selectedExamStudents && selectedExamStudents.length > 0"
            height="40vh"
            v-model="selectedAddStudents"
            :headers="headers2"
            :items="selectedExamStudents"
            show-select
            :single-select="false"
            hide-default-footer
            :items-per-page="-1"
          >
          </v-data-table>
          <v-progress-linear
            v-else
            color="red"
            height="6"
            indeterminate
          ></v-progress-linear>
        </v-card-text>
        <v-progress-linear
          v-if="savingLoading"
          color="red"
          height="6"
          indeterminate
        ></v-progress-linear>
        <v-card-actions class="card-padding d-flex justify-end">
          <v-btn
            @click="
              addStudentToLessonDialog = false;
              loadingStudents = false;
            "
            elevation="0"
            :ripple="false"
            height="43"
            class="font-weight-bold text-capitalize btn-ls btn-secondary bg-gradient-light py-3 px-6"
            >Буцаx
          </v-btn>

          <v-btn
            @click="_saveSelectedStudents"
            elevation="0"
            :ripple="false"
            height="43"
            class="font-weight-bold text-capitalize btn-ls btn-primary bg-gradient-primary py-3 px-6"
            >Бүртгэx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="removeStudentToLessonDialog"
      max-width="1000px"
      v-if="$attrs.selectedClassGroup"
    >
      <v-card class="card-shadow border-radius-xl">
        <div class="card-header-padding card-border-bottom">
          <span class="font-weight-bold text-h5 text-typo mb-0">
            Шалгуулагч хасах
            <!-- <span
              class="blue--text"
              v-if="selectedLesson && selectedLesson.classGroups"
              >{{
                selectedLesson.classGroups
                  .map((a) => a.classGroupFullName)
                  .join(", ")
              }}</span
            > -->
          </span>
        </div>
        <v-card-text class="card-padding">
          <p
            class="text-end"
            v-if="selectedRemoveStudents && selectedExamStudents"
          >
            <span class="green--text"
              >Сонгогдсон: {{ selectedRemoveStudents.length }}</span
            >
            |
            <span class="red--text">
              Сонгогдоогүй:
              {{
                selectedExamStudents.length - selectedRemoveStudents.length
              }}</span
            >
          </p>
          <v-data-table
            v-if="selectedRemoveStudents && selectedExamStudents.length > 0"
            height="40vh"
            v-model="selectedRemoveStudents"
            :headers="headers2"
            :items="selectedExamStudents"
            show-select
            :single-select="false"
            hide-default-footer
            :items-per-page="-1"
          >
          </v-data-table>
          <v-progress-linear
            v-else
            color="red"
            height="6"
            indeterminate
          ></v-progress-linear>
        </v-card-text>
        <v-progress-linear
          v-if="savingLoading"
          color="red"
          height="6"
          indeterminate
        ></v-progress-linear>
        <v-card-actions class="card-padding d-flex justify-end">
          <v-btn
            @click="
              selectedRemoveStudents = null;
              removeStudentToLessonDialog = false;
              loadingStudents = false;
            "
            elevation="0"
            :ripple="false"
            height="43"
            class="font-weight-bold text-capitalize btn-ls btn-secondary bg-gradient-light py-3 px-6"
            >Буцаx
          </v-btn>

          <v-btn
            @click="_saveRemoveSelectedStudents"
            elevation="0"
            :ripple="false"
            height="43"
            class="font-weight-bold text-capitalize btn-ls btn-primary bg-gradient-primary py-3 px-6"
            >Xасаx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="addUnelgeeDialog"
      max-width="60%"
      v-if="selectedYearFinalExam && selectedExamStudents"
    >
      <v-card>
        <v-card-title>
          <span class="font-weight-bold">
            Үнэлгээний бүртгэл | {{ selectedYearFinalExam.EXAM_NAME }} |
            {{ selectedYearFinalExam.EXAM_TYPE }}</span
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="addUnelgeeDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-title v-if="selectedYearFinalExam && $attrs.selectedClassGroup">
          Бүлгийн код:
          <span class="blue--text">{{
            $attrs.selectedClassGroup.STUDENT_GROUP_ID
          }}</span
          >, Шалгалтын код:
          <span class="blue--text">{{
            selectedYearFinalExam.TEST_COMPONENT_SESSION_ID
          }}</span>
        </v-card-title>

        <v-card-text
          v-if="selectedExamStudents && selectedExamStudents.length > 0"
        >
          <v-data-table
            :headers="unelgeeDialogHeaders"
            :items="selectedExamStudents"
            class="elevation-1"
            hide-default-footer
            :items-per-page="-1"
            fixed-header
            height="600px"
          >
            <template v-slot:item.score="{ item }">
              <input
                v-if="!item.inReviewing"
                v-model.number="item.score"
                style="
                  border: 2px solid #bbb; /* green border */
                  padding: 10px;
                  border-radius: 2px;
                "
              />
              <span> {{ item.score }}</span>
            </template>
            <template v-slot:item.percentage="{ item }">
              <span>{{ item.score }}%</span>
            </template>
            <template v-slot:item.grade="{ item }">
              <span>{{ item.grade }}</span>
            </template>

            <template v-slot:item.status="{ item }">
              <span v-if="item.isSaved" text style="color: green"
                >Бүртгэгдсэн</span
              >
              <span v-else-if="item.isConfirmed" text color="green"
                >Батлагдсан</span
              >
              <span v-else-if="item.isCanceled" text color="red"
                >Цуцлагдсан</span
              >
              <span v-else-if="item.inReviewing" text style="color: #f2b905"
                >Xянагдаж байгаа</span
              >
              <span v-else text style="color: #2196f3">Бүртгээгүй</span>
            </template>
            <!-- <template v-slot:item.status>
        
            </template> -->
          </v-data-table>
        </v-card-text>
        <v-card-text v-if="loading">
          <v-progress-linear
            color="red"
            height="6"
            indeterminate
          ></v-progress-linear>
        </v-card-text>
        <v-card-actions class="py-4">
          <v-spacer></v-spacer>
          <v-btn @click="_cancelScores">Буцах</v-btn>
          <v-btn
            @click="_saveScores"
            color="bg-gradient-info"
            dark
            v-if="!_isAllInReviewing(selectedExamStudents)"
            >Хадгалах</v-btn
          >
          <v-btn
            @click="_sendScoresToManager"
            color="red"
            dark
            v-if="!_isAllInReviewing(selectedExamStudents)"
            >Илгээх</v-btn
          >
          <!-- v-if="selectedAddStudents && selectedAddStudents.length > 0" -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showSaveESISResponseDialog"
      max-width="50%"
      v-if="saveESISresponse"
    >
      <v-card>
        <v-card-title class="headline">Илгээсэн мэдээ </v-card-title>
        <v-card-text>
          Xариу мессеж:
          <strong>{{ saveESISresponse.data.RESPONSE_MESSAGE }}</strong
          >, Илгээлтийн төлөв: <strong>{{ saveESISresponse.status }}</strong
          >, Код: <strong>{{ saveESISresponse.data.SUCCESS_CODE }}</strong>
        </v-card-text>
        <v-card-text>
          <div style="max-height: 500px; overflow-y: auto; overflow-x: auto">
            <v-data-table
              :headers="ESISresponseHeader"
              :items="saveESISresponse.data.RESULT"
              class="elevation-1"
              hide-default-footer
            >
              <template v-slot:item.index="{ index }">
                <strong>{{ index + 1 }}</strong>
              </template>

              <!-- Example: Customize name column too -->
              <template v-slot:item.PERSON_ID="{ item }">
                {{ item.PERSON_ID }}
              </template>
              <template v-slot:item.RESPONSE_INFO="{ item }">
                {{ item.RESPONSE_INFO }}
              </template>
            </v-data-table>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="_closeESISResponseDialog">Xааx</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showSaveESISResponseDialog2"
      max-width="80%"
      v-if="saveESISresponse2"
    >
      <v-card>
        <v-card-title class="headline black--text">
          <span class="blue--text">{{ selectedYearFinalExam.EXAM_NAME }}</span>
          - ESIS xадгалсан дүнгүүдийн төлөв xараx
        </v-card-title>
        <v-card-text>
          Xариу мессеж:
          <strong>{{ saveESISresponse2.data.RESPONSE_MESSAGE }}</strong
          >, Илгээлтийн төлөв: <strong>{{ saveESISresponse2.status }}</strong
          >, Код: <strong>{{ saveESISresponse2.data.SUCCESS_CODE }}</strong>
        </v-card-text>
        <v-card-text>
          <div style="max-height: 500px; overflow-y: auto; overflow-x: auto">
            <v-data-table
              :headers="ESISresponseHeader2"
              :items="saveESISresponse2.data.RESULT"
              class="elevation-1"
              hide-default-footer
            >
              <template v-slot:item.index="{ index }">
                <strong>{{ index + 1 }}</strong>
              </template>

              <template v-slot:item.PERSON_ID="{ item }">
                {{ item.PERSON_ID }}
              </template>
              <template v-slot:item.APPROVAL_STATUS_NAME="{ item }">
                <span
                  :class="_getStatusColor(item.APPROVAL_STATUS)"
                  class="py-1 px-2"
                  >{{ item.APPROVAL_STATUS_NAME }}</span
                >
              </template>
              <!-- <template v-slot:item.RESPONSE_INFO="{ item }">
                {{ item.RESPONSE_INFO }}
              </template> -->
            </v-data-table>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="_closeESISResponseDialog2">Xааx</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { sync } from "vuex-pathify";
import axios from "axios";
const fb = require("@/firebaseConfig.js");
export default {
  data() {
    return {
      tokenData: null,
      savingLoading: false,
      domainAddress: "https://hub-test.esis.edu.mn",

      saveESISresponse: null,
      saveESISresponse2: null,
      showSaveESISResponseDialog: false,
      showSaveESISResponseDialog2: false,

      ESISresponseHeader: [
        { text: "#", value: "index", sortable: false },
        { text: "PERSON_ID", value: "PERSON_ID" },
        { text: "RESPONSE_INFO", value: "RESPONSE_INFO" },
      ],

      ESISresponseHeader2: [
        { text: "#", value: "index", sortable: false },
        { text: "DISPLAY_NAME", value: "DISPLAY_NAME" },
        { text: "PERSON_ID", value: "PERSON_ID" },

        { text: "APPROVAL_STATUS_NAME", value: "APPROVAL_STATUS_NAME" },
        { text: "ATTENDANCE_REASON_NAME", value: "ATTENDANCE_REASON_NAME" },
        { text: "EXAM_NAME", value: "EXAM_NAME" },

        { text: "GRADE_CODE", value: "GRADE_CODE" },
        { text: "GRADE_ID", value: "GRADE_ID" },
        { text: "PERCENTILE", value: "PERCENTILE" },
        { text: "SCORE", value: "SCORE" },
      ],

      loading: false,
      selectedYearFinalExam: null,
      addUnelgeeDialog: false,

      unelgeeDialogHeaders: [
        { text: "№", value: "index", sortable: false },
        { text: "Овог нэр", value: "name" },
        { text: "Регистр", value: "REGISTER" },
        { text: "Ирц", value: "attendance" },
        { text: "Авсан оноо", value: "score", sortable: false },
        { text: "Хувь", value: "percentage" },
        { text: "Дүн", value: "grade" },
        { text: "Төлөв", value: "status", sortable: false },
      ],

      headers2: [
        {
          text: "№",
          align: "start",
          sortable: true,
          value: "index",
        },
        {
          text: "Нэр",
          align: "start",
          sortable: true,
          value: "FIRST_NAME",
        },
        {
          text: "Овог",
          align: "start",
          sortable: true,
          value: "LAST_NAME",
        },
        {
          text: "Бүлэг",
          align: "start",
          sortable: true,
          value: "STUDENT_GROUP_NAME",
        },

        {
          text: "Регистр",
          align: "start",
          sortable: true,
          value: "REGISTER",
        },
        {
          text: "Нэмсэн огноо",
          align: "start",
          sortable: true,
          value: "bday",
        },
      ],

      selectedRemoveStudents: null,
      removeStudentToLessonDialog: false,

      selectedAddStudents: null,
      addStudentToLessonDialog: false,

      selectedExamStudents: null,

      loadingStudents: false,

      headers: [
        { text: "№", value: "index", fixed: true },
        { text: "Шалгалтын төрөл", value: "EXAM_NAME", width: "230px" },
        { text: "Шалгуулагч", value: "icons", sortable: false },
        { text: "Үйлдэл", value: "actions", sortable: false },
        { text: "Шалгуулагч", value: "number_Students", width: "5%" },
        { text: "Бүртгээгүй", value: "number_NoScoreSaved", width: "5%" },
        { text: "Бүртгэсэн", value: "number_ScoreSaved", width: "5%" },
        {
          text: "Хянагдаж байгаа",
          value: "number_ScoreInReviewing",
          width: "5%",
        },
        { text: "Хянагдсан", value: "number_ScoreInReviewed", width: "5%" },
        { text: "Цуцлагдсан", value: "number_ScoreCanceled", width: "5%" },
        { text: "Баталсан", value: "number_ScoreApproved", width: "5%" },
        { text: "Эхлэх хугацаа", value: "BEGIN_DATE_TIME" },
        { text: "Дуусах хугацаа", value: "END_DATE_TIME" },
        { text: "ESIS", value: "actions2", sortable: false },
      ],
      // items: [
      //   {
      //     index: 1,
      //     EXAM_TYPE: "Заавал",
      //     categoryID: "1",
      //     EXAM_NAME: "12-р ангийн Математик",
      //     students: 16,
      //     not_registered: 0,
      //     registered: 0,
      //     reviewing: 0,
      //     reviewed: 0,
      //     cancelled: 0,
      //     approved: 0,
      //     BEGIN_DATE_TIME: "2025-03-18",
      //     END_DATE_TIME: "2025-07-31",
      //   },
      //   {
      //     index: 2,
      //     EXAM_TYPE: "Заавал",
      //     categoryID: "1",
      //     EXAM_NAME: "12-р ангийн Нэгдмэл агуулга",
      //     students: 16,
      //     not_registered: 0,
      //     registered: 0,
      //     reviewing: 0,
      //     reviewed: 0,
      //     cancelled: 0,
      //     approved: 0,
      //     BEGIN_DATE_TIME: "2025-03-18",
      //     END_DATE_TIME: "2025-07-31",
      //   },
      //   {
      //     index: 3,
      //     EXAM_TYPE: "Гадаад хэл",
      //     categoryID: "2",
      //     EXAM_NAME: "12-р ангийн Англи хэл",
      //     students: 0,
      //     not_registered: 0,
      //     registered: 0,
      //     reviewing: 0,
      //     reviewed: 0,
      //     cancelled: 0,
      //     approved: 0,
      //     BEGIN_DATE_TIME: "2025-03-18",
      //     END_DATE_TIME: "2025-07-31",
      //   },
      //   {
      //     index: 4,
      //     EXAM_TYPE: "Гадаад хэл",
      //     categoryID: "2",
      //     EXAM_NAME: "12-р ангийн Орос хэл",
      //     students: 0,
      //     not_registered: 0,
      //     registered: 0,
      //     reviewing: 0,
      //     reviewed: 0,
      //     cancelled: 0,
      //     approved: 0,
      //     BEGIN_DATE_TIME: "2025-03-18",
      //     END_DATE_TIME: "2025-07-31",
      //   },
      //   {
      //     index: 5,
      //     EXAM_TYPE: "Сонгон",
      //     categoryID: "3",
      //     EXAM_NAME: "12-р ангийн Биологи",
      //     students: 0,
      //     not_registered: 0,
      //     registered: 0,
      //     reviewing: 0,
      //     reviewed: 0,
      //     cancelled: 0,
      //     approved: 0,
      //     BEGIN_DATE_TIME: "2025-03-18",
      //     END_DATE_TIME: "2025-07-31",
      //   },
      //   {
      //     index: 6,
      //     EXAM_TYPE: "Сонгон",
      //     categoryID: "3",
      //     EXAM_NAME: "12-р ангийн Газарзүй",
      //     students: 0,
      //     not_registered: 0,
      //     registered: 0,
      //     reviewing: 0,
      //     reviewed: 0,
      //     cancelled: 0,
      //     approved: 0,
      //     BEGIN_DATE_TIME: "2025-03-18",
      //     END_DATE_TIME: "2025-07-31",
      //   },

      // ],
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
    sortedItems() {
      if (this.$attrs.finalExamsCalendars)
        return [...this.$attrs.finalExamsCalendars].sort(
          (a, b) => a.categoryID - b.categoryID
        );
      else return [];
    },
  },

  methods: {
    _getStatusColor(status) {
      return status == "PENDING"
        ? "amber"
        : status == "CHECKED"
        ? "yellow"
        : status == "REJECTED"
        ? "red"
        : status == "APPROVED"
        ? "green"
        : "blue";
    },
    _isAllInReviewing(students) {
      var inReviewing = students.filter((s) => s.inReviewing);
      if (inReviewing.length == students.length) {
        return true;
      } else {
        return false;
      }
    },
    _openAddStudentDialogToLesson(exam) {
      this.selectedYearFinalExam = exam;
      this.loadingStudents = true;
      this.selectedAddStudents = [];

      var examRef = this.userData.school.ref
        .collection("stateExams-2025")
        .doc(
          "classGroupId-" +
            String(this.$attrs.selectedClassGroup.STUDENT_GROUP_ID)
        )
        .collection("exams")
        .doc("examId-" + this.selectedYearFinalExam.TEST_COMPONENT_SESSION_ID);

      examRef
        .collection("students")
        .orderBy("FIRST_NAME", "asc")
        .get()
        .then((docs) => {
          this.selectedExamStudents = [];
          var counter = 0;
          var tmpStudents = [];
          docs.forEach((doc) => {
            let stud = doc.data();
            stud.id = doc.id;
            stud.ref = doc.ref;
            tmpStudents.push(stud);
          });
          var noScores = tmpStudents.filter(
            (ss) => !ss.score && !ss.sentToManager
          );
          var withScores = tmpStudents.filter(
            (ss) => ss.score && !ss.sentToManager
          );
          if (exam.number_NoScoreSaved != noScores.length) {
            exam.ref
              .update({
                number_NoScoreSaved: noScores.length,
              })
              .then(() => {});
          }
          if (exam.number_ScoreSaved != withScores.length) {
            exam.ref
              .update({
                number_ScoreSaved: withScores.length,
              })
              .then(() => {});
          }

          for (const stud of this.$attrs.classStudents) {
            var isAlreadyAdded = tmpStudents.find(
              (s) => String(s.PERSON_ID) == String(stud.PERSON_ID)
            );
            if (!isAlreadyAdded) {
              counter++;
              stud.index = counter;
              this.selectedExamStudents.push(stud);
            }
          }
          if (this.selectedExamStudents.length == 0) {
            this.$swal.fire({
              title: "Шалгуулагчид бүгд нэмэгдсэн байна!",
              icon: "warning",
            });
            this.loadingStudents = false;
          } else {
            this.loadingStudents = false;
            this.addStudentToLessonDialog = true;
          }
        });
    },
    _saveSelectedStudents() {
      console.log("saveing....", this.selectedAddStudents);
      console.log("this.selectedYearFinalExam", this.selectedYearFinalExam);
      console.log(
        "TEST_ID",
        this.selectedYearFinalExam.TEST_COMPONENT_SESSION_ID
      );
      this.savingLoading = true;
      if (this.selectedYearFinalExam.TEST_COMPONENT_SESSION_ID) {
        if (this.selectedAddStudents && this.selectedAddStudents.length > 0) {
          var examRef = this.userData.school.ref
            .collection("stateExams-2025")
            .doc(
              "classGroupId-" +
                String(this.$attrs.selectedClassGroup.STUDENT_GROUP_ID)
            )
            .collection("exams")
            .doc(
              "examId-" + this.selectedYearFinalExam.TEST_COMPONENT_SESSION_ID
            );
          var batch = fb.db.batch();
          for (const student of this.selectedAddStudents) {
            var tmpStudent = {};
            tmpStudent["FIRST_NAME"] = student.FIRST_NAME;
            tmpStudent["LAST_NAME"] = student.LAST_NAME;
            tmpStudent["PERSON_ID"] = student.PERSON_ID;
            tmpStudent["DATE_OF_BIRTH"] = student.DATE_OF_BIRTH;
            tmpStudent["STUDENT_GROUP_ID"] = student.STUDENT_GROUP_ID;
            tmpStudent["STUDENT_GROUP_NAME"] = student.STUDENT_GROUP_NAME;
            tmpStudent["GENDER_CODE"] = student.GENDER_CODE;
            tmpStudent["REGISTER"] = student.REGISTER;
            tmpStudent["schoolId"] = this.userData.school.id;
            tmpStudent["year"] = 2025;
            tmpStudent.deleted = false;
            tmpStudent.addAtDate = new Date();
            tmpStudent.addByRef = this.userData.ref;
            tmpStudent.addByName = this.userData.DISPLAY_NAME
              ? this.userData.DISPLAY_NAME
              : this.userData.firstName
              ? this.userData.firstName
              : this.userData.email;

            var studRef = examRef.collection("students").doc(student.PERSON_ID);
            // console.log(studRef.path, "examRef");
            batch.set(studRef, tmpStudent, { merge: true });

            console.log(
              student,
              student.FIRST_NAME,
              this.$attrs.selectedClassGroup.STUDENT_GROUP_NAME
            );
          } //for

          batch.commit().then(async () => {
            //todolast
            // await this._updateRegisteredStudentsNumbers(
            //   this.selectedYearFinalExam
            // );
            this.selectedYearFinalExam.ref.update({
              number_Students:
                this.selectedYearFinalExam.categoryID != 1
                  ? this.selectedYearFinalExam.number_Students +
                    this.selectedAddStudents.length
                  : this.selectedYearFinalExam.number_Students,
              number_NoScoreSaved:
                this.selectedYearFinalExam.number_NoScoreSaved +
                this.selectedAddStudents.length,
            });
            this.savingLoading = false;
            this.selectedAddStudents = [];
            this.selectedYearFinalExam = null;
            this.addStudentToLessonDialog = false;
          });
        }
      }
    },
    _removeStudentToLesson(exam) {
      this.selectedYearFinalExam = exam;
      this.loadingStudents = true;

      var examRef = this.userData.school.ref
        .collection("stateExams-2025")
        .doc(
          "classGroupId-" +
            String(this.$attrs.selectedClassGroup.STUDENT_GROUP_ID)
        )
        .collection("exams")
        .doc("examId-" + this.selectedYearFinalExam.TEST_COMPONENT_SESSION_ID);

      examRef
        .collection("students")
        .orderBy("FIRST_NAME", "asc")
        .get()
        .then((docs) => {
          this.selectedExamStudents = [];
          this.selectedRemoveStudents = [];
          var counter = 0;
          docs.forEach((doc) => {
            counter++;
            let stud = doc.data();
            stud.id = doc.id;
            stud.ref = doc.ref;
            stud.index = counter;
            this.selectedExamStudents.push(stud);
          });
          if (this.selectedExamStudents.length == 0) {
            this.$swal.fire({
              title: "Шалгуулагчид байхгүй байна!",
              text: "Шалгуулагчид нэмээрэй!",
              icon: "warning",
            });
            this.selectedYearFinalExam.ref.update({ number_NoScoreSaved: 0 });

            this.loadingStudents = false;
          } else {
            this.loadingStudents = false;
            this.removeStudentToLessonDialog = true;
          }
        });
    },
    _saveRemoveSelectedStudents() {
      this.savingLoading = true;
      console.log(this.selectedYearFinalExam.ref.path, "selectedYearFinalExam");
      console.log(this.selectedRemoveStudents.length, "selectedRemoveStudents");
      if (
        this.selectedRemoveStudents &&
        this.selectedRemoveStudents.length > 0
      ) {
        var batch = fb.db.batch();
        for (const student of this.selectedRemoveStudents) {
          batch.delete(student.ref);
        }
        batch.commit().then(async () => {
          // await this._updateRegisteredStudentsNumbers(
          //   this.selectedYearFinalExam
          // );

          var noScores = this.selectedRemoveStudents.filter(
            (ss) => !ss.score && !ss.sentToManager
          );
          var withScores = this.selectedRemoveStudents.filter(
            (ss) => ss.score && !ss.sentToManager
          );

          this.selectedYearFinalExam.ref
            .update({
              number_NoScoreSaved:
                this.selectedYearFinalExam.number_NoScoreSaved -
                noScores.length,

              number_ScoreSaved:
                this.selectedYearFinalExam.number_ScoreSaved -
                withScores.length,

              number_Students:
                this.selectedYearFinalExam.number_Students -
                this.selectedRemoveStudents.length,
            })
            .then(() => {
              this.savingLoading = false;
              this.selectedRemoveStudents = [];
              this.selectedYearFinalExam = null;
              this.removeStudentToLessonDialog = false;
              this.$forceUpdate();
            });
        });
      }
    },
    _print(item) {
      console.log(item.ref.path, "item...");
    },
    _closeESISResponseDialog2() {
      this.saveESISresponse2 = null;
      this.showSaveESISResponseDialog2 = !this.showSaveESISResponseDialog2;
    },
    _closeESISResponseDialog() {
      console.log("dklfjsjdf");
      this.saveESISresponse = null;
      this.showSaveESISResponseDialog = !this.showSaveESISResponseDialog;
    },
    _retriveExams() {
      console.log(this.sortedItems, "sortedItems");
      this.loading = true;
      var callPath =
        "https://hub.esis.edu.mn/svc/api/hub/service/exam/component/sessions/" +
        this.$attrs.selectedClassGroup.STUDENT_GROUP_ID;

      this.tmpFinalExamsCalendars = null;
      axios
        .post(
          "https://us-central1-digitalschool-3f1e9.cloudfunctions.net/getEsis",
          {
            url: callPath,
            token: this.$attrs.tokenData.token,
          }
        )
        .then((res) => {
          console.log(res.data.SUCCESS_CODE, res.data.RESULT, res);
          if (res && res.data && res.data.SUCCESS_CODE == 200) {
            for (var dataa of res.data.RESULT) {
              // console.log(dataa.EXAM_TYPE, dataa);
              // console.log(dataa.TEST_COMPONENT_SESSION_ID);
              if (dataa.EXAM_TYPE == "Заавал") dataa.categoryID = 1;
              else if (dataa.EXAM_TYPE == "Гадаад хэл") dataa.categoryID = 2;
              else if (dataa.EXAM_TYPE == "Сонгон") dataa.categoryID = 3;
              else dataa.categoryID = 4;

              dataa.number_Students = 0;
              dataa.number_NoScoreSaved = 0;

              // dataa.number_ScoreSaved = 0;
              // dataa.number_ScoreInReviewing = 0;
              // dataa.number_ScoreInReviewed = 0;
              // dataa.number_ScoreCanceled = 0;
              // dataa.number_ScoreApproved = 0;
            }
            // this.tmpFinalExamsCalendars = res.data.RESULT;
            var batch = fb.db.batch();
            for (let exam of res.data.RESULT) {
              var examRef = this.userData.school.ref
                .collection("stateExams-2025")
                .doc(
                  "classGroupId-" +
                    String(this.$attrs.selectedClassGroup.STUDENT_GROUP_ID)
                )
                .collection("exams")
                .doc("examId-" + exam.TEST_COMPONENT_SESSION_ID);
              batch.set(examRef, exam, { merge: true });
            }
            batch.commit().then(() => {
              this.loading = false;
              // this.$forceUpdate();
            });
          } else {
            if (res.data) {
              this.$swal.fire({
                title: res.data.RESPONSE_MESSAGE + ": " + res.data.SUCCESS_CODE,
                text: res.data.RESULT,
              });
            } else {
              this.$swal.fire("Error");
              //todofinal error handling
            }
          }
        });
    },
    _doUnelgee(item) {
      this.selectedYearFinalExam = item;
      // console.log(item);
      // console.log(
      //   "TEST_COMPONENT_SESSION_ID",
      //   this.selectedYearFinalExam.TEST_COMPONENT_SESSION_ID
      // );
      // console.log(
      //   "STUDENT_GROUP_ID",
      //   this.$attrs.selectedClassGroup.STUDENT_GROUP_ID
      // );

      // console.log(this.$attrs.tokenData.token);

      this.loadingStudents = true;

      var examRef = this.userData.school.ref
        .collection("stateExams-2025")
        .doc(
          "classGroupId-" +
            String(this.$attrs.selectedClassGroup.STUDENT_GROUP_ID)
        )
        .collection("exams")
        .doc("examId-" + this.selectedYearFinalExam.TEST_COMPONENT_SESSION_ID);

      examRef
        .collection("students")
        .orderBy("FIRST_NAME", "asc")
        .get()
        .then(async (docs) => {
          this.selectedExamStudents = [];
          var counter = 0;
          docs.forEach((doc) => {
            counter++;
            let stud = doc.data();
            stud.id = doc.id;
            stud.ref = doc.ref;
            stud.index = counter;
            stud.name =
              (stud.LAST_NAME ? stud.LAST_NAME[0] : "") + "." + stud.FIRST_NAME;
            this.selectedExamStudents.push(stud);
          });

          var noScores = this.selectedExamStudents.filter((ss) => !ss.score);
          var withScores = this.selectedExamStudents.filter((ss) => ss.score);

          this.selectedYearFinalExam.ref
            .update({
              number_NoScoreSaved: noScores.length,

              number_ScoreSaved: withScores.length,
            })
            .then(() => {
              if (this.selectedExamStudents.length == 0) {
                this.$swal.fire({
                  title: "Шалгуулагчид байхгүй байна!",
                  text: "Шалгуулагчид нэмээрэй!",
                  icon: "warning",
                });
                this.loadingStudents = false;
              } else {
                this.addUnelgeeDialog = true;
                this.loadingStudents = false;
              }
            });
        });
    },
    _cancelScores() {
      console.log("dfsdf");
      this.selectedYearFinalExam = null;
      this.selectedAddStudents = null;
      this.selectedRemoveStudents = null;
      this.selectedExamStudents = null;
      this.addUnelgeeDialog = false;
    },
    _callEsisSavedInfo(selectedExam) {
      console.log(selectedExam);
      this.selectedYearFinalExam = selectedExam;
      //TEST_COMPONENT_SESSION_ID
      //selectedClassGroup
      console.log(this.$attrs.tokenData.token);
      this.loading = true;
      var urlLink =
        this.domainAddress + "/svc/api/hub/service/exam/candidate/grades/";
      urlLink = urlLink + this.$attrs.selectedClassGroup.STUDENT_GROUP_ID + "/";
      urlLink = urlLink + selectedExam.TEST_COMPONENT_SESSION_ID;
      console.log(urlLink, "urlLink");
      axios
        .post(
          "https://us-central1-digitalschool-3f1e9.cloudfunctions.net/getEsis",
          {
            url: urlLink,
            token: this.$attrs.tokenData.token,
          }
        )
        .then((res) => {
          this.loading = false;
          this.saveESISresponse2 = res;
          console.log(res.data.SUCCESS_CODE, res.data.RESULT, res);
          this.showSaveESISResponseDialog2 = !this.showSaveESISResponseDialog2;
          if (res && res.data && res.data.SUCCESS_CODE == 200) {
            //
          }
        });
    },
    _saveScores() {
      var batch = fb.db.batch();
      for (const student of this.selectedExamStudents) {
        console.log(student.name, student.PERSON_ID, student.score);
        if (
          student.score &&
          !student.inReviewing &&
          !student.isCanceled &&
          !student.isConfirmed
        ) {
          student.isSaved = true;
          student.savedAt = new Date();
          batch.update(student.ref, student);
        }
        // student.inReviewing = false;
        //   student.sendToManager = false;
        //   student.isCanceled = false;
        //   student.isConfirmed = false;
      } //for
      batch.commit().then(async () => {
        // await this._updateRegisteredStudentsNumbers(this.selectedYearFinalExam);
        var withScores = 0;
        var noScores = 0;
        for (var stud of this.selectedExamStudents) {
          if (stud.score > 0) withScores++;
          else noScores++;
        }
        await this.selectedYearFinalExam.ref
          .update({
            number_ScoreSaved: withScores,
            number_NoScoreSaved: noScores,
            number_Students: this.selectedExamStudents.length,
          })
          .then(() => {
            this.selectedYearFinalExam = null;
            this.selectedExamStudents = null;
            this.addUnelgeeDialog = !this.addUnelgeeDialog;
          });
      });
    },
    async _sendScoresToManager() {
      var studentWitoutScore = this.selectedExamStudents.filter(
        (ss) => !ss.score
      );
      if (studentWitoutScore.length > 0) {
        this.$swal.fire({
          title: studentWitoutScore.length + " дүнгүй сурагч байна!",
          text: "Шалгуулагчийн оноог БҮРЭН бүртгэж, менежерт илгээнэ!",
          icon: "warning",
        });
      } else {
        this.loading = true;
        var examRef = this.userData.school.ref
          .collection("stateExams-2025")
          .doc(
            "classGroupId-" +
              String(this.$attrs.selectedClassGroup.STUDENT_GROUP_ID)
          )
          .collection("exams")
          .doc(
            "examId-" + this.selectedYearFinalExam.TEST_COMPONENT_SESSION_ID
          );

        console.log(examRef.path, "path");
        // var domainAddress = "https://hub.esis.edu.mn";
        var domainAddress = "https://hub-test.esis.edu.mn";
        var urlLink = domainAddress + "/svc/api/hub/exam/candidate/save";
        //inEvent ADD - Нэмэх , DELETE - хасах
        if (
          this.$attrs.tokenData.token &&
          this.selectedYearFinalExam &&
          this.selectedYearFinalExam.TEST_COMPONENT_SESSION_ID &&
          this.$attrs.selectedClassGroup &&
          this.$attrs.selectedClassGroup.STUDENT_GROUP_ID
        ) {
          var batch = fb.db.batch();
          var scoredStudentsToESIS = [];
          for (const student of this.selectedExamStudents) {
            console.log(
              student.name,
              student.PERSON_ID,
              student.score,
              student.status
            );
            if (student.score) {
              student.isSaved = false;
              student.inReviewing = true;
              student.sendToManager = true;
              student.isCanceled = false;
              student.isConfirmed = false;

              student.sentToManagerAt = new Date();
              batch.update(student.ref, student);
            }
            scoredStudentsToESIS.push({
              person_id: student.PERSON_ID,
              attendance_reason: "CAME",
              score: student.score,
              grade_id: student.score,
              percentile: student.score,
            });
          } //for
          console.log(scoredStudentsToESIS, "scoredStudentsToESIS");

          batch.commit().then(async () => {
            // await this._updateRegisteredStudentsNumbers(this.selectedYearFinalExam);
            var numberOfSendToManager = 0;
            // var numberOfSaved = 0;
            // var numberOfNoScore = 0;

            for (var stud of this.selectedExamStudents) {
              if (stud.score > 0 && stud.inReviewing) numberOfSendToManager++;
              // else if (stud.score > 0 && !stud.isSaved) numberOfSaved++;
              // else numberOfNoScore++
            }
            await this.selectedYearFinalExam.ref
              .update({
                number_ScoreInReviewing: numberOfSendToManager,
                number_ScoreSaved: 0,
                number_NoScoreSaved: 0,
                sentToManager: true,
                sentToManagerAt: new Date(),
                lastUpdateAt: new Date(),
                lastUpdateByRef: this.userData.ref,
              })
              .then(() => {
                this.selectedYearFinalExam = null;
                this.selectedExamStudents = null;
                this.addUnelgeeDialog = !this.addUnelgeeDialog;
              });
          });

          var bodyData = {
            inEvent: "ADD",
            inStudentGroupId: this.$attrs.selectedClassGroup.STUDENT_GROUP_ID,
            inTestComponentSessionID:
              this.selectedYearFinalExam.TEST_COMPONENT_SESSION_ID,
            inStudentList: scoredStudentsToESIS,
          };
          console.log("writing.. ok starting...");
          console.log("urlLink", urlLink);
          console.log("bodyData", bodyData);
          console.log("---");
          console.log(this.$attrs.tokenData.token);
          var startTime = new Date();
          await axios
            .post(
              "https://us-central1-digitalschool-3f1e9.cloudfunctions.net/esisWrite",
              {
                url: urlLink,
                token: this.$attrs.tokenData.token,
                data: bodyData,
              }
            )
            .then((res) => {
              this.loading = false;
              var diff = this.timeDifference(startTime, new Date());
              console.log(
                "RESPONSE from ESIS",
                res,
                res.status == 200,
                res.data.SUCCESS_CODE
              );
              this.saveESISresponse = res;
              if (res && res.status == 200 && res.data.SUCCESS_CODE) {
                this.$swal.fire({
                  title: res.data.RESPONSE_MESSAGE,
                  text: res.data.RESULT + "<p>" + diff + "</p>",
                });
              } else {
                this.$swal.fire({
                  title: res.data.RESPONSE_MESSAGE,
                  text: res.data.RESULT + "<p>" + diff + "</p>",
                });
              }

              this._saveResponse(res, urlLink, bodyData);

              this.showSaveESISResponseDialog =
                !this.showSaveESISResponseDialog;
            });
        }

        this.selectedYearFinalExam = null;
        this.addUnelgeeDialog = !this.addUnelgeeDialog;
      }
    },
    _saveResponse(res, urlLink, bodyData) {
      fb.db
        .collection("finalize-2024")
        .doc(this.userData.school.id)
        .collection("exams")
        .doc(
          String(
            "examId-" + this.selectedYearFinalExam.TEST_COMPONENT_SESSION_ID
          ) +
            "-classGroup" +
            String(this.$attrs.selectedClassGroup.STUDENT_GROUP_ID)
        )
        .add({
          url: urlLink,
          token: this.$attrs.tokenData.token,
          data: bodyData,
          response: res,
          createdAt: new Date(),
        });
    },
    _getDatee(str) {
      if (str) return str.replace("T00:00:00.000Z", "");
      else return str;
    },
    async _updateRegisteredStudentsNumbers(exam) {
      var registeredStudents = await this._getRegisteredStudents(exam);
      var dataa = {
        // number_Students: this.selectedAddStudents.length,
        number_NoScoreSaved: this._findStudentsNumberNOScore(
          registeredStudents.docs
        ),
        number_ScoreSaved: this._findStudentsNumberWithScore(
          registeredStudents.docs
        ),
      };
      console.log(dataa, "final dataa");
      // await exam.ref.update(dataa);
      var withScores = 0;
      for (var stud of registeredStudents.docs) {
        console.log(stud.FIRST_NAME, stud.score, stud.score > 0);
        if (stud.score > 0) withScores++;
      }
      await exam.ref.update({
        withScores: withScores,
      });
      // number_ScoreSaved: 0,
      // number_ScoreInReviewing: 0,
      // number_ScoreInReviewed: 0,
      // number_ScoreCanceled: 0,
      // number_ScoreApproved: 0,
    },
    _findStudentsNumberWithScore(students) {
      return students.filter((ss) => ss.score).length;
    },
    _findStudentsNumberNOScore(students) {
      return students.filter((ss) => !ss.score).length;
    },
    async _getRegisteredStudents(exam) {
      var examRef = this.userData.school.ref
        .collection("stateExams-2025")
        .doc(
          "classGroupId-" +
            String(this.$attrs.selectedClassGroup.STUDENT_GROUP_ID)
        )
        .collection("exams")
        .doc("examId-" + exam.TEST_COMPONENT_SESSION_ID);

      var studs = await examRef.collection("students").get();
      return studs;
    },

    timeDifference(startTime, endTime) {
      const start = new Date(startTime);
      const end = new Date(endTime);
      const diffMs = end - start;

      // const hours = Math.floor(diffMs / (1000 * 60 * 60));
      const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

      return `${minutes}m ${seconds}s`;
    },
  },
};
</script>

 
<style scoped>
.v-btn {
  text-transform: none;
}
/* Fix the first column (№) */
.fixed-table >>> th:first-child,
.fixed-table >>> td:first-child {
  position: sticky;
  left: 0;
  background: white;
  z-index: 3;
  border-right: 1px solid #ddd;
}

/* Fix the second column (Шалгалтын төрөл) */
.fixed-table >>> th:nth-child(2),
.fixed-table >>> td:nth-child(2) {
  position: sticky;
  left: 50px; /* Adjust width based on column size */
  background: white;
  z-index: 3;
  border-right: 1px solid #ddd;
}
</style>

<!-- todo

1. exams unshix
2. suragch nemeh collection oloh
3. hadgalah, ilgeeh
4. status unshih -->